import {t} from "@lingui/core/macro";
import {StyleSheet} from "aphrodite";
import * as React from "react";

import Clickable from "@khanacademy/wonder-blocks-clickable";
import {View} from "@khanacademy/wonder-blocks-core";
import {PhosphorIcon} from "@khanacademy/wonder-blocks-icon";
import {color} from "@khanacademy/wonder-blocks-tokens";

import caretLeftIcon from "@phosphor-icons/core/regular/caret-left.svg";
import caretRightIcon from "@phosphor-icons/core/regular/caret-right.svg";

interface Props {
    expanded: boolean;
    editorId: string;
    onClick?: () => unknown;
}

export default function Expander(props: Props): React.ReactElement {
    const collapsed = !props.expanded;

    return (
        <Clickable
            style={styles.expander}
            onClick={props.onClick}
            aria-label={t`Toggle editor panel`}
            aria-expanded={collapsed ? "false" : "true"}
            aria-controls={props.editorId}
        >
            {() => (
                <View>
                    <PhosphorIcon
                        icon={collapsed ? caretLeftIcon : caretRightIcon}
                        size="medium"
                    />
                </View>
            )}
        </Clickable>
    );
}

const styles = StyleSheet.create({
    expander: {
        cursor: "pointer",
        color: color.offBlack,
        width: 32,
        height: 40,
        border: `1px solid ${color.offBlack16}`,
        borderInlineStart: "none",
        borderRadius: "0 50% 50% 0",
        // Align with left edge of container
        marginInlineStart: -1,
        // Align with 321 toggle
        marginBlockStart: -36,
    },
});
